/**
 * A few frames spread over a chosen video as base64 JPEG (no data: prefix), small enough to send for a suggestion
 * of what to count: from the video itself when the browser can play it, else from the still frames of a .ts.
 */

const WIDTH = 768;
const QUALITY = 0.8;
const SEEK_TIMEOUT_MS = 15000;

const toJpeg = (source, w, h) => {
	const width = Math.min(WIDTH, w);
	const canvas = document.createElement('canvas');
	canvas.width = width;
	canvas.height = Math.round((width * h) / w);
	canvas.getContext('2d').drawImage(source, 0, 0, canvas.width, canvas.height);
	return canvas.toDataURL('image/jpeg', QUALITY).split(',')[1];
};

/** n evenly spaced picks from still frames [{ t, bitmap }]. */
export const framesFromStills = (stills, n = 5) => {
	if (!stills?.length) return [];
	const picks = Array.from({ length: Math.min(n, stills.length) }, (_, k) =>
		Math.floor(((k + 0.5) * stills.length) / Math.min(n, stills.length))
	);
	return picks.map(i => stills[i].bitmap).map(b => toJpeg(b, b.width, b.height));
};

/** n frames at evenly spaced times of a playable video URL. */
export const framesFromVideo = (url, duration, n = 5) =>
	new Promise(resolve => {
		const v = document.createElement('video');
		v.muted = true;
		v.preload = 'auto';
		v.playsInline = true;
		const out = [];
		const times = Array.from({ length: n }, (_, k) => ((k + 0.5) / n) * duration);
		const done = () => {
			clearTimeout(timer);
			v.removeAttribute('src');
			v.load();
			resolve(out);
		};
		const timer = setTimeout(done, SEEK_TIMEOUT_MS);
		v.addEventListener('seeked', () => {
			if (v.videoWidth) out.push(toJpeg(v, v.videoWidth, v.videoHeight));
			if (out.length >= times.length) done();
			else v.currentTime = times[out.length];
		});
		v.addEventListener('loadedmetadata', () => {
			v.currentTime = times[0];
		});
		v.addEventListener('error', done);
		v.src = url;
	});
